import React, { Component, ErrorInfo, ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error in WhatsApp route:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: "32px",
          textAlign: "center",
          fontFamily: "Urbanist, sans-serif",
          background: "#fff",
          borderRadius: "8px",
          border: "1px solid #fee2e2",
          margin: "20px"
        }}>
          <h2 style={{ color: "#dc2626", fontSize: "18px", marginBottom: "8px" }}>Something went wrong</h2>
          <p style={{ color: "#4b5563", fontSize: "14px", marginBottom: "16px" }}>
            An unexpected error occurred while loading this section.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "8px 16px",
              background: "#4f46e5",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: 600
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
